import React, { ReactElement } from 'react';
import { Route, Routes as RouteSwitch, useLocation, useParams } from 'react-router-dom';

import { IS_PRODUCTION } from 'appConstants';
import SubHeader from 'components/SubHeader';
import { PageContent } from 'components/page';
import { usePermissions } from 'hooks';
import ForbiddenPage from 'pages/public/AccessDenied';
import { StepsLoading } from 'pages/public/Loading';
import NotFoundPage from 'pages/public/NotFoundPage';

import { Games, LandingPage, Quizzes, Referrals, RewardPromo, Stamps, Surveys } from './Campaign';

const readyForProduction = ['stamps', 'games'];

const SubHeaderWrap = ({ campaign }: { campaign: ReactElement }) => {
  const featureTabs = [
    { key: 'stamps', label: 'Stamps' },
    { key: 'games', label: 'Games' },
    { key: 'referrals', label: 'Referrals' },
    { key: 'surveys', label: 'Surveys' },
    { key: 'quizzes', label: 'Quizzes' },
    { key: 'rewardpromo', label: 'Reward Promo' }
  ];

  const campaignNavigationTabs = [
    ...(IS_PRODUCTION ? featureTabs.filter(ft => readyForProduction.includes(ft.key)) : featureTabs)
  ];

  const location = useLocation();

  return (
    <>
      <SubHeader
        subTabs={campaignNavigationTabs}
        defaultSubTab={location.pathname.split('/').pop()}
      />
      {campaign}
    </>
  );
};

const wrapSubHeader = (campaign: ReactElement) => <SubHeaderWrap campaign={campaign} />;

const Campaigns = () => {
  const params = useParams();
  const location = useLocation();

  const { loading: permissionsLoading, canView } = usePermissions('business_intelligence');

  if (permissionsLoading) {
    return <StepsLoading />;
  }

  if (!canView) {
    return <ForbiddenPage />;
  }

  const featureRoutes = [
    {
      key: 'stamps',
      route: <Route key={'stamps'} path="stamps/*" element={wrapSubHeader(<Stamps />)} />
    },
    {
      key: 'games',
      route: <Route key={'games'} path="games/*" element={wrapSubHeader(<Games />)} />
    },
    {
      key: 'referrals',
      route: <Route key={'referrals'} path="referrals/*" element={wrapSubHeader(<Referrals />)} />
    },
    {
      key: 'surveys',
      route: <Route key={'surveys'} path="surveys/*" element={wrapSubHeader(<Surveys />)} />
    },
    {
      key: 'quizzes',
      route: <Route key={'quizzes'} path="quizzes/*" element={wrapSubHeader(<Quizzes />)} />
    },
    {
      key: 'rewardpromo',
      route: (
        <Route key={'rewardpromo'} path="rewardpromo/*" element={wrapSubHeader(<RewardPromo />)} />
      )
    }
  ];

  return (
    <PageContent style={{ overflow: 'visible' }}>
      <div className="container">
        <RouteSwitch>
          <Route path="" element={<LandingPage />} />
          {featureRoutes.map(r => r.route)}
          <Route element={<NotFoundPage />} />
        </RouteSwitch>
      </div>
    </PageContent>
  );
};

export default Campaigns;
